// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__XHvaX","circle":"Tag_circle__lp2GZ","label":"Tag_label__Omwb3"};